import { Component, OnInit } from '@angular/core';
import { FiltrosProducaoRetornoService } from '../../../../filters/filtros-producaoretorno.service';
import { ProducaoRetornoService } from '../../../../services/producaoretorno.service';
import { ProducaoIndustrial } from '../../../../types/ProducaoIndustrial.type';

@Component({
  selector: 'app-producaoindustrial',
  templateUrl: './producaoindustrial.component.html',
  styleUrl: './producaoindustrial.component.css',
})
export class ProducaoIndustrialComponent implements OnInit {
  producoes: ProducaoIndustrial[] = [];
  totalRecords: number = 0;
  loading: boolean = false;

  dataInicio: string = '';
  dataFim: string = '';
  instancia: string = '';

  // Modal
  displayDetalhes: boolean = false;
  itemSelecionado: ProducaoIndustrial | null = null;

  constructor(
    private producaoRetornoService: ProducaoRetornoService,
    private filterService: FiltrosProducaoRetornoService,
  ) {}

  ngOnInit() {
    this.producoes = [];
    this.getFiltros();
  }

  getFiltros() {
    this.filterService.currentInstancia.subscribe((instancia) => {
      this.instancia = instancia;
      this.carregarDados();
    });

    this.filterService.currentDataInicio.subscribe((inicio) => {
      this.dataInicio = inicio;
      this.carregarDados();
    });

    this.filterService.currentDataFim.subscribe((fim) => {
      this.dataFim = fim;
      this.carregarDados();
    });
  }

  carregarDados() {
    if (this.instancia != '' && this.dataInicio != '' && this.dataFim != '') {
      this.loading = true;

      this.producaoRetornoService
        .getProducaoIndustrial(0, 1000, 'empresa', 'asc', this.instancia, this.dataInicio, this.dataFim)
        .subscribe({
          next: (data) => {
            this.producoes = data.content ?? data;
            this.totalRecords = data.page?.totalElements ?? data.totalElements ?? this.producoes.length;
            this.loading = false;
          },
          error: (error) => {
            console.error('Erro ao carregar produção industrial:', error);
            this.loading = false;
          }
        });
    }
  }

  showDetalhes(item: ProducaoIndustrial) {
    this.itemSelecionado = item;
    this.displayDetalhes = true;
  }
}
